import { HeroSection } from "@/components/sections/HeroSection";
import { ProblemSection } from "@/components/sections/ProblemSection";
import { TimelineSection } from "@/components/sections/TimelineSection";
import { SolutionSection } from "@/components/sections/SolutionSection";
import { HowItWorksSection } from "@/components/sections/HowItWorksSection";
import { MissionVisionSection } from "@/components/sections/MissionVisionSection";
import { ServicesSection } from "@/components/sections/ServicesSection";
import { TeamSection } from "@/components/sections/TeamSection";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { FAQSection } from "@/components/sections/FAQSection";
import { ContactSection } from "@/components/sections/ContactSection";

export function HomePage() {
  return (
    <>
      <HeroSection />
      <ProblemSection />
      {/* <TimelineSection /> */}
      <SolutionSection />
      <HowItWorksSection />
      <MissionVisionSection />
      <ServicesSection />
      <TeamSection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
    </>
  );
}
